import {initialStoreObject} from "./store";
import SimpleCollectionStore from "./SimpleCollectionStore";

export default class MailAccountsStore extends SimpleCollectionStore {
    init() {
        this.data = initialStoreObject;
    }

    doFetch(parameters, afterLoadCallback) {
        this.fetch(
            this.data,
            "api/mailAccount/get.php",
            {},
            afterLoadCallback
        );
    }

}